import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { forwardRef, useMemo, useRef, useState } from "react";
import { Box, FormHelperText, useTheme } from "@mui/material";
import { CustomInput, FormLabel, customInputSxProps } from "../FormInput";
import moment from "moment";
import React from "react";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { poperSxProps } from "../../contexts/ThemeContext/getDesignTokens";

type DatePickerProps = {
  helperText?: string;
  width?: string;
  fullWidth?: boolean;
  label?: string;
  onChange?: (value: any) => void;
  value?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  noBorder?: boolean;
  showIcon?: boolean;
};

const DatePicker = (props: DatePickerProps) => {
  const { width = "15.625rem", fullWidth = true, required, placeholder, showIcon = true, label, noBorder = false, helperText, onChange = () => {}, value, disabled = false, ...others } = props;
  const error = !!helperText;
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLElement>(null);

  const localValue: moment.Moment | null = useMemo(() => {
    if (value) {
      return moment(value);
    }
    return null;
  }, [value]);
  console.log(localValue);

  const [display, setDisplay] = useState(localValue?.isValid() ? localValue?.format("L") : "");

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Box sx={{ width: fullWidth ? "100%" : width }}>
        {label && <FormLabel error={error} label={label} required={required} />}
        <MuiDatePicker
          slotProps={{
            popper: {
              anchorEl: anchorRef.current,
              sx: {
                "& .MuiPaper-root": poperSxProps,
              },
            },
            textField: {
              InputProps: {
                size: "small",
                ref: anchorRef,
                error: error,
                disabled,
                placeholder: placeholder,
                ...others,
                sx: [
                  customInputSxProps,
                  noBorder && {
                    "&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline": {
                      border: 0,
                    },
                    "& fieldset.MuiOutlinedInput-notchedOutline": {
                      border: 0,
                    },
                  },
                ],
                value: display,
                onClick: (e) => {
                  setOpen(true);
                },
                startAdornment: showIcon && (
                  <CalendarTodayIcon
                    sx={{
                      fontSize: "18px",
                      marginRight: "8px",
                      color: "text.secondary",
                    }}
                  />
                ),
              },
            },
          }}
          value={localValue}
          open={open}
          onClose={() => setOpen(false)}
          onChange={(e) => {
            setDisplay(e?.format("L") || "");
            onChange(e?.toISOString());
          }}
          sx={{ width: "100%" }}
        />
        <FormHelperText error={error}>{helperText}</FormHelperText>
      </Box>
    </LocalizationProvider>
  );
};
export default DatePicker;
